import queryString from 'query-string';
import { API_URL } from '../../../app-config/constants';
import { LegacyReviewMini } from '../../react/features/Reviews/types';
import { get } from '../request';

const BASE = `${API_URL}/reviews/mini`;

getById.operation = 'READ';
getById.byId = true;
export function getById(reviewId: string) {
    return get(`${BASE}/${reviewId}`);
}

getAllRelevant.operation = 'READ';
export function getAllRelevant(userId: string, startDate?: string, endDate?: string) {
    const qS = queryString.stringify({ userId, startDate, endDate });
    return get<LegacyReviewMini[]>(`${BASE}/relevant-for-user?${qS}`);
}
